module.exports = __webpack_public_path__ + "img/ht21.04ed7549.png";